import React, { useState } from "react"
import { useRef } from "react";
import { useEffect } from "react"
import { Button, Modal } from "semantic-ui-react";
import logger from 'xAppLib/libs/logger';
import user_model from "models/user_model";
import { useSiteStatus } from "xAppLib/Hooks";
import { watch_user_device } from "models/online_users_model";

const DEBUG = false


function StayOnline() {

    const { grace = 10, base, pwr } = useSiteStatus('dvc_sesh')  || {}
    const [online,setOnline] = useState()
    const [revoked,setRevoked] = useState()
    const timer = useRef()
    const [loading,setLoading] = useState(false)
    const [waited,setWaited] = useState(false)


    useEffect(()=>{
        if (app.user.uid && app.dvc?.dvcid) {
            return watch_user_device('default', app.user.uid, app.dvc.dvcid, (data, revoked)=>{
                setOnline(data)
                setRevoked(revoked)
            })
        }
    },[app.user.uid, app.dvc?.dvcid])

    useEffect(()=>{
        // Wait a bit to prevent the modal from showing right away if the user is first loading the app
        const t = setTimeout(()=>setWaited(true),3000)
        return ()=>clearTimeout(t)
    },[])

    const logout = online?.logout || false

    useEffect(()=>{
        if (revoked) {
            clearTimeout(timer.current)
            setLoading(false)
            user_model.logout()
        }
    },[revoked])

    useEffect(()=>{
        if (!waited)
            return
        clearTimeout(timer.current)
        if (logout) {
            DEBUG && console.log(`timer to logout at ${grace} minutes`)
            timer.current = setTimeout(()=>{
                DEBUG && console.log(`need to logout after ${grace} minutes`)
                user_model.logout()
            },grace * 60 * 1000)
        }

        return ()=>clearTimeout(timer.current)
        
    },[logout,waited])

    if (!waited || !logout || !app.user.uid)
        return null

    return  <Modal
                dimmer="inverted"
                open
                size='small'
                className='!relative'
            >
                <Modal.Header>
                    Inactivity
                </Modal.Header>
                <Modal.Content scrolling>
                    <p>You have been inactive for a while and will be signed out soon.</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button loading={loading} onClick={()=>{
                        clearTimeout(timer.current)
                        setLoading(true)
                        logger.usg_log('::sec::', "active", "yes", {uid:app.user.uid})
                        setTimeout(()=>setLoading(false),2000)
                    }} primary>
                        Stay logged in
                    </Button>
                </Modal.Actions>
            </Modal>

}


export default StayOnline